"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const filter = (obj, callback) => Object.fromEntries(Object.entries(obj).filter(([key, value]) => callback(value, key)));
exports.default = filter;
